// client/src/components/moonbeams/MoonbeamCard.js
import { Link } from 'react-router-dom';

export default function MoonbeamCard({ template }) {
  return (
    <Link
      to={`/moonbeams/create/${template.templateid}`}
      className="block bg-white dark:bg-royal-800 border border-royal-200 dark:border-royal-600 rounded-xl overflow-hidden hover:border-gold/50 transition-all hover:-translate-y-1 hover:shadow-xl hover:shadow-gold/10"
    >
      <div
        className="aspect-[4/3] flex items-center justify-center"
        style={{ background: 'linear-gradient(180deg, #283593 0%, #1a237e 60%, #0d1339 100%)' }}
      >
        {template.previewimageurl ? (
          <img src={template.previewimageurl} alt={template.name} className="w-full h-full object-cover" />
        ) : (
          <span className="text-5xl">✨</span>
        )}
      </div>
      <div className="p-4 sm:p-5 bg-white dark:bg-royal-800">
        <span className="inline-block text-xs sm:text-sm font-semibold uppercase tracking-wider bg-gold/15 dark:bg-transparent text-gold-dark dark:text-gold px-2 py-0.5 dark:px-0 dark:py-0 rounded">
          {template.categoryname}
        </span>
        <h3 className="text-base sm:text-lg text-royal-900 dark:text-white font-display font-semibold mt-1.5 leading-snug">
          {template.name}
        </h3>
        {template.description && (
          <p className="text-royal-500 dark:text-royal-300 text-sm mt-1.5 line-clamp-2 leading-relaxed">{template.description}</p>
        )}
        <div className="flex gap-2 mt-3">
          {template.allowphoto && (
            <span className="text-xs bg-royal-100 dark:bg-royal-700 text-royal-600 dark:text-royal-200 px-2 py-0.5 rounded">Photo</span>
          )}
          {template.isbirthday && (
            <span className="text-xs bg-rose-100 dark:bg-valentine-pink/20 text-rose-600 dark:text-valentine-pink px-2 py-0.5 rounded">Birthday</span>
          )}
        </div>
      </div>
    </Link>
  );
}